import MuiTab from "@material-ui/core/Tab";
import MuiTabs from "@material-ui/core/Tabs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TEditorMode, TTabOptionType } from "../types";
import { useTabStyles, useTabsStyles } from "./themes";

type Props = {
  handleChange?: (mode: TEditorMode) => void;
  options: TTabOptionType[];
  initialMode: TEditorMode;
};

const TabsBar = (props: Props) => {
  const { options, handleChange } = props;
  const [selectedTab, setSelectedTab] = useState<TEditorMode>(
    props.initialMode
  );
  const tabClasses = useTabStyles();
  const tabsClasses = useTabsStyles();
  const { t } = useTranslation();
  React.useEffect(() => {
    if (handleChange) handleChange(selectedTab);
  }, []);
  return (
    <MuiTabs classes={tabsClasses} value={selectedTab}>
      {props.options.map((tab, index) => (
        <MuiTab
          key={index}
          classes={tabClasses}
          fullWidth={false}
          value={tab.value}
          label={t("tabsBar." + tab.title)}
          onClick={() => {
            setSelectedTab(tab.value);
            if (handleChange) handleChange(tab.value);
          }}
        />
      ))}
    </MuiTabs>
  );
};

export default TabsBar;
